import { useState } from "react"
import Image from "next/image"

// Adds a fallback image source to the Next Image component
export default function CrfImage(props) {
    const { src, fallbackSrc, ...rest } = props
    const [imgSrc, setImgSrc] = useState(src)

    return (
        <Image
            {...rest}
            src={imgSrc}
            onError={() => {
                setImgSrc(fallbackSrc)
            }}
            alt={props.alt}
            // style={{
            //     maxWidth: "100%",
            //     height: "auto"
            // }}
        />
    )
}
